





import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toaster } from 'react-hot-toast';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import Legal from "./Pages/Legal";
import NotFound from "./Pages/NotFound";
import Appointment from "./Pages/Appointment";
import ProductDetail from "./Components/ProductDetails"; // create this page
import Navbar from "./Components/Navbar";
import Cart from './Components/Cart';
import Checkout from './Components/Checkout';
import Address from './Components/Address';
import { CartProvider } from "./Context/CartContext";
import Shop from "./Components/Shop";
import Footer from "./Components/Footer";
import About from "./Components/About";
import ContactUs from "./Components/Contact";
import EditProfile from "./Components/EditProfile";
import OrderComponents from "./Components/OrderComponets";

import { AuthProvider } from "./Context/AuthContext";
import PersonalInfo from "./Components/PersonalInfo";
import WishlistComponet from "./Components/WishlistComponet";
import AddressComponent from "./Components/AddressComponet";
import { ToastContainer } from "react-toastify";
import NeedHelp from "./Components/NeedHelp";
import Cartcomponents from "./Components/Cartcomponets";
import SearchSection from "./Components/SearchSection";
import Searchproduct from "./Components/Searchproduct";
import AllProduct from "./Components/AllProduct";




function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />

      <AuthProvider>
        <CartProvider>
          <Router>
            <Navbar />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/appointment" element={<Appointment />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              {/* <Route path="/cart" element={<Cart />} /> */}
              <Route path="/shop" element={<Shop />} />
              <Route path="/address" element={<Address />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/searchproduct" element={<Searchproduct />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/wishlist" element={<WishlistComponet />} />
              <Route path="/addressinfo" element={<AddressComponent />} />
              <Route path="/profile" element={<PersonalInfo />} />
              <Route path="/order/:id" element={<OrderComponents />} />
              <Route path="/faq" element={<NeedHelp />} />
              <Route path="/cart" element={<Cartcomponents />} />
              <Route path="*" element={<NotFound />} />
               <Route path="/products/:subCategoryName" element={<AllProduct />} />
            </Routes>

            <Footer />
          </Router>
        </CartProvider>
      </AuthProvider>

    </div>
  );
}

export default App;
